<style>
.bottom-nav .btn .btn__content {
    font-size: 14px;
}
</style>
<template>
    <v-col>
        <v-bottom-navigation :value="true" color="grey lighten-2" v-model="path" app id="bottom-nav">

            <v-btn text color="primary" :disabled="!hasCustomer || !hasAgreement" to="/customer">
                <span>{{ $t('Aktivity') }}</span>
                <v-icon>account_box</v-icon>
            </v-btn>

            <v-btn text color="primary" :disabled="!hasAgreement" to="/reservations">
                <span>{{ $t('Rezervace') }}</span>
                <v-icon>assignment</v-icon>
            </v-btn>

            <v-btn text color="primary" :disabled="!$oauth2.hasAccessToken() || (hasCustomer && !hasAgreement)"
                   to="/eshop">
                <span>{{ $t('Obchod') }}</span>
                <v-icon>store</v-icon>
            </v-btn>

            <v-menu max-width="960" max-height="600" v-model="basketHover" :close-on-content-click="false"
                    :open-on-hover="!isBasket" offset-overflow :disabled="!hasItems">
                <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click.native="basketHover = false" text color="primary" :disabled="!hasItems"
                           to="/basket">
                        <span>{{ $t('Košík') }}</span>
                        <v-badge :color="badgeColor" v-model="hasItems" :disabled="!hasItems">
                            <span slot="badge" v-if="hasItems">{{ hasItems ? basket.items.length : 0 }}</span>
                            <v-icon>shopping_cart</v-icon>
                        </v-badge>
                    </v-btn>
                </template>
                <basket-table></basket-table>
            </v-menu>

            <v-btn text color="primary" :disabled="!hasItems || necessaryCredit > 0" to="/payment">
                <span>{{ $t('Pokladna') }}</span>
                <v-icon>credit_card</v-icon>
            </v-btn>

            <!-- <v-menu :close-on-content-click="false" open-on-hover offset-overflow :disabled="!hasAgreement || !hasItems || necessaryCredit > 0 || isPayment">
              <v-btn @click="$router.push({ name: 'payment' })" text color="primary" :disabled="!hasAgreement || !hasItems || necessaryCredit > 0" v-on="on" value="/payment">
                <span>{{ $t('Pokladna') }}</span>
                <v-icon>credit_card</v-icon>
              </v-btn>
              <payment-order></payment-order>
             </v-menu> -->

        </v-bottom-navigation>
    </v-col>
</template>
<script>
import BasketMixin from '@/mixins/basket-mixin.js'
import CustomerMixin from '@/mixins/customer-mixin.js'
import StorageMixin from '@/mixins/storage-mixin.js'
import BasketTable from '@/components/basket-table.vue'
// import PaymentOrder from '@/components/payment-order.vue'

export default {
    data() {
        return {
            basketHover: false
        }
    },
    mixins: [BasketMixin, CustomerMixin, StorageMixin],
    components: {
        'basket-table': BasketTable
        // 'payment-order': PaymentOrder
    },
    computed: {
        badgeColor() {
            return this.necessaryCredit > 0 ? 'red' : 'primary'
        },
        isBasket() {
            return this.$route.name === 'basket'
        },
        isPayment() {
            return this.$route.name === 'payment'
        },
        path: {
            get() {
                return this.$route.path
            },
            set() {
            }
        }
    }
}
</script>
